<div class="progress-container ">
    <div class="progress-goal"></div>
    <span [style.left]="(value)+'%'" class="progress-value color-grey">
        <span *ngIf="!isHideLabel">{{value}}</span>
        {{label}}</span>
    <span [style.width]="value+'%'" class="progress-content animate"></span>
</div>